export default __webpack_public_path__ + "static/media/building-ikiga-gs.b17c5f02.png";